import React, { useState } from 'react';
import {
  PageContainer,
  Header,
  Title,
  Description,
  ContactGrid,
  ContactForm,
  FormGroup,
  Label,
  Input,
  TextArea,
  SubmitButton,
  ContactInfo,
  InfoSection,
  InfoItem,
  InfoIcon,
  InfoContent,
  InfoLabel,
  InfoLink
} from './styles';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically handle the form submission
    console.log('Form submitted:', formData);
    // Reset form
    setFormData({
      name: '',
      email: '',
      company: '',
      message: ''
    });
  };

  return (
    <PageContainer>
      <Header>
        <Title>Contact Us</Title>
        <Description>
          Get in touch with our team to discuss partnership opportunities, licensing inquiries, or any questions about our plasma technology solutions.
        </Description>
      </Header>

      <ContactGrid>
        <ContactForm onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="name">Name</Label>
            <Input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="email">Email</Label>
            <Input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="company">Company</Label>
            <Input
              type="text"
              id="company"
              name="company"
              value={formData.company}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="message">Message</Label>
            <TextArea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <SubmitButton type="submit">Send Message</SubmitButton>
        </ContactForm>

        <ContactInfo>
          <InfoSection>
            <InfoItem>
              <InfoIcon>📧</InfoIcon>
              <InfoContent>
                <InfoLabel>Email</InfoLabel>
                <InfoLink href="mailto:contact@coreplasma.com">contact@coreplasma.com</InfoLink>
              </InfoContent>
            </InfoItem>
          </InfoSection>
        </ContactInfo>
      </ContactGrid>
    </PageContainer>
  );
};

export default ContactPage; 